import React, { useState, useRef, useEffect } from 'react';
import axios from '../api/axiosConfig';
import { FaPlus, FaMinus } from 'react-icons/fa';

function CollapsibleCreateBoardForm({ onBoardCreated }) {
  const [expanded, setExpanded] = useState(false);
  const [name, setName] = useState('');
  const wrapperRef = useRef(null);

  // Klick außerhalb + ESC schließt
  useEffect(() => {
    if (!expanded) return;

    const handleOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setExpanded(false);
      }
    };
    const handleEsc = (e) => {
      if (e.key === 'Escape') setExpanded(false);
    };

    document.addEventListener('mousedown', handleOutside);
    document.addEventListener('keydown', handleEsc);
    return () => {
      document.removeEventListener('mousedown', handleOutside);
      document.removeEventListener('keydown', handleEsc);
    };
  }, [expanded]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post('/boards', { name, invitedUsers: [] });
      onBoardCreated?.(res.data);
      setName('');
      setExpanded(false);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="collapsible-section" ref={wrapperRef}>
      <button
        className="collapsible-button"
        onClick={() => setExpanded((v) => !v)}
        aria-expanded={expanded}
        aria-controls="create-board-content"
      >
        {expanded ? <FaMinus /> : <FaPlus />} Neues Board erstellen
      </button>
      {expanded && (
        <div className="collapsible-content" id="create-board-content">
          <h3>Neues Board erstellen</h3>
          <form onSubmit={handleSubmit}>
            <div className="field">
              <label htmlFor="new-board-name">Board Name</label>
              <input
                id="new-board-name"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                className="form-input"
              />
            </div>
            <button type="submit" className="submit-button">
              Board erstellen
            </button>
          </form>
        </div>
      )}
    </div>
  );
}

export default CollapsibleCreateBoardForm;
